import type { FaqEntry } from "@/lib/json-ld";

export const RESIDENTIAL_PRICING_FAQS: FaqEntry[] = [
  {
    q: "What is the price of the Proxidize Residential Proxies?",
    a: "Proxidize Residential Proxies start at $1/GB.",
  },
  {
    q: "What payment methods do you accept?",
    a: "We accept all credit/debit cards.",
  },
  {
    q: "Does unused bandwidth expire?",
    a: "Never. Unused data rolls over to the next month automatically. Even if you cancel, your remaining bandwidth stays in your account and can be used whenever you want.",
  },
  {
    q: "Can I scale up or down?",
    a: "Yes. Adjust your bandwidth at any time with no penalties and no commitments.",
  },
  {
    q: "Is KYC required?",
    a: "Yes. We require KYC (Know Your Customer) verification from all customers to maintain compliance and prevent misuse of our network.",
  },
  {
    id: "money-back-guarantee",
    q: "Is there a money-back guarantee?",
    a: "Yes. Refund requests submitted in writing within 30 days are honored provided no more than 10 GB has been used on the individual proxy, up to a maximum of two refunds per customer account.",
  },
  {
    q: "Are there any usage restrictions?",
    a: "Yes. We only allow legal and ethical use cases, as described in our Acceptable Use Policy. Use relating to the adult industry or .gov domains is not permitted.",
  },
  {
    q: "Do I need to contact sales to get started?",
    a: "No. Select your bandwidth and pay to reserve it. Enterprise customers needing more than 1 TB or custom pricing can contact sales.",
  },
  {
    q: "When does KYC verification happen, and can I try before I pay?",
    a: "Account creation is free, but there's no free proxy trial — you select and pay for a plan first, then complete Tier 1 KYC verification from your account. Proxy access stays locked until verification is approved, which is usually quick.",
  },
];
